/**
 * The Adsterra slots on the public meeting page (/meeting/<id>, on every site with Adsterra units of its own): the same
 * slot the site's data pages carry (site/js/ad-slots.js), collapsed until a sandboxed frame fills it once it nears the
 * screen. Never on the signed-in dashboard: main.tsx renders it on the public page only, and not for team accounts or
 * staff. A site without units draws nothing; a size it lacks is its native unit.
 */
import { useEffect, useRef } from "react";
import { siteAdSlotHtml, adSiteOf, initAds } from "../../site/js/ad-slots.js";

export function AdSlot({ unit }: { unit: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const html = siteAdSlotHtml(adSiteOf(window.location), unit, { cls: "ad-slot--data" });
  useEffect(() => { if (ref.current) initAds(ref.current); }, []);
  if (!html) return null;
  return <div ref={ref} className="public-ad" dangerouslySetInnerHTML={{ __html: html }} />;
}

/** The leaderboard after the meeting. */
export const LeaderboardAd = () => <AdSlot unit="leaderboard" />;

/** A 300x250 between the meeting's impact report and its agenda (MeetingPage's Overview), on a long agenda only. */
export const MidPageAd = () => <AdSlot unit="300x250" />;
